import { styled } from '@linaria/react'
import { ButtonSC } from 'atoms/Button'
import { AccountInfoSC } from 'blocks/AccountInfo'
import { AudioAutoQualitySC } from 'blocks/AudioAutoQuality'
import { PageTitleSC } from 'blocks/Container/PageTitle'
import { SettingsNestedPageTextBlockSC } from 'blocks/Container/SettingsNestedPageTextBlock'
import { MaxVideoQualitySC } from 'blocks/MaxVideoQuality'
import { VideoPreviewsSC } from 'blocks/VideoPreviews'
import { ChangeUsernamePasswordFormSC } from 'containers/ChangeUsernamePasswordForm'
import { SettingsMenuContainerSC } from 'containers/SettingsMenu'
import { FIXED_INDENTS, MEDIA } from 'vars/index'

export const SettingsNestedPageContainerSC = styled.div<{
  maxWidth?: string
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  margin-top: var(${FIXED_INDENTS.INDENT_100});

  ${MEDIA.MAX_1239} {
    padding: 0 var(${FIXED_INDENTS.INDENT_40});
    margin-top: var(${FIXED_INDENTS.INDENT_60});
  }

  & > ${ButtonSC} {
    position: absolute;
    top: 0;
    left: 42px;

    ${MEDIA.MAX_1239} {
      left: 8px;
    }
  }

  ${PageTitleSC} {
    width: 100%;
    margin-bottom: var(${FIXED_INDENTS.INDENT_60});

    ${MEDIA.MIN_768} {
      width: ${({ maxWidth }) => maxWidth || 'auto'};
    }

    ${MEDIA.MIN_1240} {
      margin-bottom: var(${FIXED_INDENTS.INDENT_120});
    }

    ${MEDIA.MIN_1640} {
      margin-bottom: var(${FIXED_INDENTS.INDENT_160});
    }

    ${MEDIA.MAX_1239} {
      margin-top: var(${FIXED_INDENTS.INDENT_140});
    }
  }

  // hidable block, so padding bottom
  ${VideoPreviewsSC} {
    margin-bottom: var(${FIXED_INDENTS.INDENT_50});

    ${MEDIA.MIN_600} {
      margin-bottom: var(${FIXED_INDENTS.INDENT_60});
    }

    ${MEDIA.MIN_1240} {
      margin-bottom: var(${FIXED_INDENTS.INDENT_80});
    }
  }

  ${AudioAutoQualitySC} {
    margin-top: var(${FIXED_INDENTS.INDENT_50});

    ${MEDIA.MIN_600} {
      margin-top: var(${FIXED_INDENTS.INDENT_60});
    }

    ${MEDIA.MIN_1240} {
      margin-top: var(${FIXED_INDENTS.INDENT_80});
    }
  }

  // first settings menu container
  ${SettingsMenuContainerSC} {
  }

  // next settings menu containers
  ${SettingsMenuContainerSC} + ${SettingsMenuContainerSC} {
    margin-top: var(${FIXED_INDENTS.INDENT_50});

    ${MEDIA.MIN_600} {
      margin-top: var(${FIXED_INDENTS.INDENT_60});
    }

    ${MEDIA.MIN_1240} {
      margin-top: var(${FIXED_INDENTS.INDENT_80});
    }
  }

  ${AccountInfoSC},
  ${SettingsMenuContainerSC},
  ${MaxVideoQualitySC},
  ${AudioAutoQualitySC},
  ${VideoPreviewsSC},
  ${SettingsNestedPageTextBlockSC},
  ${ChangeUsernamePasswordFormSC} {
    ${MEDIA.MIN_768} {
      width: ${({ maxWidth }) => maxWidth || 'auto'};
    }
  }
`
